import Badge from 'components/Badge'
import { PopOverItem } from 'components/PopOver/types'
import { LeadDetails } from 'types/global'

export enum Actions {
  create = 'create',
  deactivate = 'deactivate',
  delete = 'delete',
  markAsPrimary = 'markAsPrimary',
  reactivate = 'reactivate',
  update = 'update',
}

export const DEFAULT_OPTIONS: PopOverItem[] = [
  {
    value: Actions.markAsPrimary,
    label: 'mark_as_primary_lbl',
    icon: ['far', 'flag'],
  },
  {
    value: Actions.deactivate,
    label: 'deactivate_contact_lbl',
    icon: ['fal', 'minus-octagon'],
    iconColor: 'red',
  },
  {
    value: Actions.delete,
    label: 'contact_delete_lbl',
    labelColor: 'red',
    icon: ['far', 'trash-alt'],
    iconColor: 'red',
  },
]

export const mutateMenuOptions = (
  actionsToUpdate: Array<Actions>,
  data: Partial<PopOverItem>,
  actions: PopOverItem[],
) => actions?.map((option) => (actionsToUpdate?.includes(option?.value as Actions) ? { ...option, ...data } : option))

export const getMenuOptions = (
  isLast: boolean,
  isActive: boolean,
  isPrimary: boolean,
  isPrimaryOptionExcluded = false,
) => {
  if (isLast) {
    return DEFAULT_OPTIONS.filter((i) => {
      i.value === Actions.markAsPrimary
    })
  }

  if (!isActive) {
    return DEFAULT_OPTIONS.filter((i) => i.value === Actions.delete)
  }

  if (isPrimary || isPrimaryOptionExcluded) {
    return DEFAULT_OPTIONS.filter((i) => i.value !== Actions.markAsPrimary)
  }

  return DEFAULT_OPTIONS
}

export const getBadge = (isActive: boolean, isPrimary: boolean) => {
  if (isActive && isPrimary) {
    return <Badge color="orange" text="primary_contact_lbl" />
  }

  if (!isActive) {
    return <Badge color="lightGray" text="deactivated_contact_lbl" />
  }
}

export const getDeletedContactInfo = (
  initialValues: LeadDetails.ContactPerson,
  currentValues: LeadDetails.ContactPerson,
): string[] => {
  const initialContactIds = [
    ...initialValues.email.filter((i) => !!i.id).map((i) => String(i.id)),
    ...initialValues.mobile.filter((i) => !!i.id).map((i) => String(i.id)),
  ]
  const currentContactIds = [
    ...currentValues.email.filter((i) => !!i.id && i.value).map((i) => String(i.id)),
    ...currentValues.mobile.filter((i) => !!i.id && i.value).map((i) => String(i.id)),
  ]

  return initialContactIds.filter((i) => i && !currentContactIds.includes(i))
}
